import { IUserRanking } from '../types';

export function getUserData(notEmpty: boolean, highscore: IUserRanking, isUser: boolean, ownRankName: string) {
  let userName = '';
  let picture: string | undefined = '';
  let rankingScore = 0;
  let score = 0;
  if (notEmpty) {
    userName = isUser ? ownRankName : highscore.name;
    picture = highscore.picture;
    rankingScore = highscore.ranking;
    score = highscore.score;
  }
  return {
    userName,
    picture,
    rankingScore,
    score,
  };
}
